import _ from 'lodash';

export function authConfig(
  $httpProvider,
  envServiceProvider,
  jwtOptionsProvider,
  jwtInterceptorProvider
) {
  'ngInject';

  // Every request that starts with /api is an api request
  const isApiRequest = (options) => _.startsWith(options.url, '/api');

  // JWT interceptor
  jwtOptionsProvider.config({
    whiteListedDomains: ['localhost', envServiceProvider.apiHost]
  });

  jwtInterceptorProvider.tokenGetter = (options, userService) => {
    'ngInject';
    if (isApiRequest(options)) {
      return userService.getToken();
    }
    return null;
  };

  $httpProvider.interceptors.push('jwtInterceptor');

  $httpProvider.interceptors.push('authResponseObserver');
}
